// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { togglePopup } from '../../../../../components/popupPanel/popupActions';
import { intercomShowMessages } from '../../../../../analytics/analyticsActions';

// Components
import Button from '../../../../../components/buttons/Button';
import Spinner from '../../../../../components/loaders/Spinner';
import ElectronLink from '../../../../../components/electron/ElectronLink';
import AnchorButton from '../../../../../components/buttons/AnchorButton';

// Styles
import './TrashLoadMoreButton.scss';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    handleContactSupportButtonClick: () => {
        dispatch(togglePopup(PopupIds.TRASH));
        dispatch(intercomShowMessages());
    },
});

const TrashLoadMoreContent = (props) => {
    const {
        hasMore,
        hasOlder,
        currentUserIsSubscribed,
        trashFetching,
        dispatchLoadMoreTrash,
        handleContactSupportButtonClick,
        isContentFullyRendered,
    } = props;

    if (trashFetching || !isContentFullyRendered) return <Spinner show />;

    if (!hasMore && !currentUserIsSubscribed) {
        if (!hasOlder) {
            return (
                <div className="trash-end-of-results">
                    <p className="cta">Nothing older in trash</p>
                </div>
            );
        }

        return (
            <div className="trash-end-of-results">
                <p className="question">Want to recover something that was deleted more than a week ago?</p>
                <p className="cta">
                    Upgrade for three months history&nbsp;&nbsp;
                    <ElectronLink to="/free-plan/upgrade">Find out more</ElectronLink>
                </p>
            </div>
        );
    }

    if (!hasMore) {
        return (
            <div className="trash-end-of-results">
                <p className="question">Looking for something older than this?</p>
                <p className="cta">
                    <AnchorButton onClickFn={handleContactSupportButtonClick}>Contact support</AnchorButton>
                    &nbsp;<span>and we can restore it for you</span>
                </p>
            </div>
        );
    }

    return (
        <Button className="load-more" onClick={dispatchLoadMoreTrash}>
            Load more...
        </Button>
    );
};

const TrashLoadMoreButton = (props) => (
    <div className="TrashLoadMoreButton">
        <TrashLoadMoreContent {...props} />
    </div>
);

TrashLoadMoreContent.propTypes = TrashLoadMoreButton.propTypes = {
    currentUserIsSubscribed: PropTypes.bool,
    trashFetching: PropTypes.bool,
    hasMore: PropTypes.bool.isRequired,
    dispatchLoadMoreTrash: PropTypes.func.isRequired,
    handleContactSupportButtonClick: PropTypes.func,
    isContentFullyRendered: PropTypes.bool,
};

export default connect(null, mapDispatchToProps)(TrashLoadMoreButton);
